/**
 * <countdown-timer>: shows the time left until 23:59:59 on the visitor's own clock (so in their own
 * time zone) as HH:MM:SS, updated every second, and starts over at midnight.
 * Used by blocks/_announcement.liquid where the announcement text contains [countdown].
 */
class CountdownTimer extends HTMLElement {
  /** @type {number | undefined} */
  #interval;

  connectedCallback() {
    this.#tick();
    window.clearInterval(this.#interval);
    this.#interval = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#interval);
  }

  #tick() {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    const seconds = Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000));
    this.textContent = [Math.floor(seconds / 3600), Math.floor((seconds % 3600) / 60), seconds % 60]
      .map((part) => String(part).padStart(2, '0'))
      .join(':');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
